<script>
import ImageWrapper from '@/components/atoms/ImageWrapper'
import ButtonLoader from '@/components/atoms/ButtonLoader'
import { mapGetters } from 'vuex'

export default {
    name: 'Recommendation',

    components: { ImageWrapper, ButtonLoader },

    props: {
        model: {
            type: Object,
            default: () => {},
        },
        block: Boolean,
    },

    computed: {
        ...mapGetters({
            currency: 'active/currency',
            loading: 'recommender/loading',
        }),
    },
    methods: {
        openMealSelector() {
            this.$emit('open', this.model)
        },
        selectMeal() {
            this.$emit('select', this.model)
        },
    },
}
</script>

<template lang="pug">
.recommendation.card.cursor-pointer(@click="openMealSelector" :class="{'block-recommendation': block}")
    .recommendation-image
        image-wrapper.overflow-hidden(:src="model.image" :class="block ? 'border-radius-sm' : 'border-radius-top-cardf'" width="var(--recommendation-image-width)" height="var(--recommendation-image-height)" cover)
        button-loader.btn.btn-light.btn-icon.btn-xs.btn-round.shadow-sm(@click="selectMeal" :loading="loading === model.id" stop)
            icon(icon="fa-solid fa-plus")
    .recommendation-content 
        span.text-ellipsis-2.line-1.text-sm {{ model.name }}
        .d-flex.gap-3.mt-2(v-if="currency")
            span.text-sm(:class="{'text-primary': model.original_price}") {{ model.price | toCurrency(currency.locale, currency.currency_code) }}
            s.text-sm.text-73(v-if="model.original_price") {{ model.original_price | toCurrency(currency.locale, currency.currency_code) }}

</template>
